<template>
  <div id="rateassist-basic-details-tab-content">
    <div class="row">
      <div class="col-xs-12">
        <blockquote>
          Details
        </blockquote>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label for="basic-details-service-contract" class="form-label">Service Contract</label>
          <input type="text" class="form-control" id="basic-details-service-contract" v-model="basicDetails.serviceContract"/>
        </div>
        <div class="form-group">
          <label for="basic-details-description" class="form-label">Description</label>
          <textarea rows="5" class="form-control" id="basic-details-description" v-model="basicDetails.description"></textarea>
        </div>
        <div class="form-group">
          <label for="basic-details-notes" class="form-label">Notes</label>
          <textarea rows="5" class="form-control" id="basic-details-notes" v-model="basicDetails.notes"></textarea>
        </div>
      </div>
      <div class="col-xs-12">
        <hr>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-group">
          <label for="date-from" class="form-label">Effective From</label>
          <input class="mai-date" type="date" v-model="basicDetails.effectiveFrom"/>
        </div>
        <div class="form-group">
          <label for="date-from" class="form-label">Effective To</label>
          <input class="mai-date" type="date" v-model="basicDetails.effectiveTo"/>
        </div>
        <div class="form-group">
          <label class="form-label" for="basic-details-ratePer">Rates Per</label>
          <select v-model="basicDetails.ratesPer" id="basic-details-ratePer" class="form-control">
            <option value=""></option>
            <option v-for="option in ratesPer" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
        <div class="form-group" v-show="modeShouldShow">
          <label class="form-label" for="basic-details-mode">Mode</label>
          <select v-model="basicDetails.mode" id="basic-details-mode" class="form-control">
            <option value=""></option>
            <option v-for="option in modes" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-group">
          <label for="basic-details-density" class="form-label">Density</label>
          <input type="number" step="0.01" class="form-control" id="basic-details-density" v-model="basicDetails.density"/>
        </div>
        <div class="form-group">
          <label class="form-label" for="basic-details-density-type">Minimum Density Type</label>
          <select v-model="basicDetails.densityType" id="basic-details-density-type" class="form-control">
            <option value=""></option>
            <option v-for="option in densities" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="basic-details-sc">Service Class</label>
          <select v-model="basicDetails.serviceClass" id="basic-details-sc" class="form-control">
            <option value=""></option>
            <option v-for="option in serviceTypes" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div v-show="containerTypeShouldShow">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="form-label" for="basic-details-container-type">Container Types</label>
            <div class="input-group">
              <select v-model="containerType" id="basic-details-container-type" class="form-control">
                <option value=""></option>
                <option v-for="option in containers" :value="option">{{ option.name }}</option>
              </select>
              <span class="input-group-addon" @click="addContainerType">
                <i class="fa fa-plus"></i>
              </span>
            </div>
          </div>
          <ul class="list-group">
            <li class="list-group-item" v-for="(ct, i) in basicDetails.containerTypeSelections">
              <div class="clearfix">
                {{ ct.dataOption }}
                <span class="pull-right">
                  <div class="btn btn-danger" @click="remove('containerTypeSelections', i)">
                    <i class="fa fa-times"></i>
                  </div>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-show="woodLooseShouldShow">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="form-label" for="basic-details-wood-loose">Wood / Loose</label>
            <div class="input-group">
              <select v-model="woodLoose" id="basic-details-wood-loose" class="form-control">
                <option value=""></option>
                <option v-for="option in woodLooses" :value="option">{{ option.name }}</option>
              </select>
              <span class="input-group-addon" @click="addWoodLoose">
                <i class="fa fa-plus"></i>
              </span>
            </div>
          </div>
          <ul class="list-group">
            <li class="list-group-item" v-for="(wl, i) in basicDetails.woodLooseSelections">
              <div class="clearfix">
                {{ wl.dataOption }}
                <span class="pull-right">
                  <div class="btn btn-danger" @click="remove('woodLooseSelections', i)">
                    <i class="fa fa-times"></i>
                  </div>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  import dateConfig from '../../../../static/js/date-picker-config.json'
  import event from '../../../event'
  export default {
    name: 'BasicDetails',
    components: {
      DatePicker
    },
    mixins: [ LookupHelperMixin ],
    props: [ 'modeShouldShow', 'containerTypeShouldShow', 'woodLooseShouldShow', 'details' ],
    data () {
      return {
        basicDetails: {
          serviceContract: '',
          description: '',
          notes: '',
          effectiveTo: window.getYMDDate(),
          effectiveFrom: window.getYMDDate(),
          mode: '',
          ratesPer: '',
          density: 6.5,
          densityType: '',
          serviceClass: '',
          woodLooseSelections: [],
          containerTypeSelections: []
        },
        containerType: '',
        woodLoose: '',
        dateOption: dateConfig,
        effectiveTo: {
          time: window.getYMDDate()
        },
        effectiveFrom: {
          time: window.getYMDDate()
        },
        initialised: false
      }
    },
    computed: {
      modes () {
        return this.sortedOptions('MODE')
      },
      ratesPer () {
        return this.sortedOptions('BREAKPOINT_UNIT')
      },
      densities () {
        return this.sortedOptions('UNIT_TYPE')
      },
      containers () {
        return this.sortedOptions('CONTAINER_TYPE')
      },
      woodLooses () {
        return this.sortedOptions('WOOD_LOOSE')
      },
      serviceTypes () {
        return this.sortByName(this.$store.getters['systemOption/serviceTypes'])
      }
    },
    methods: {
      remove (prop, i) {
        this.basicDetails[prop].splice(i, 1)
      },
      sortByName (arr) {
        let copy = [ ...arr ]
        return copy.sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      sortedOptions (type) {
        return this.sortByName(this.getSystemOptions(type))
      },
      addWoodLoose () {
        if (this.woodLoose !== '' && !this.contains(this.woodLoose, this.basicDetails.woodLooseSelections)) {
          this.basicDetails.woodLooseSelections.push({
            category: 'WOOD_LOOSE',
            dataOptionId: this.woodLoose.id,
            dataOption: this.woodLoose.name
          })
          this.woodLoose = ''
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure you have selected a wood loose option and it is not already in the current selections' })
        }
      },
      addContainerType () {
        if (this.containerType !== '' && !this.contains(this.containerType, this.basicDetails.containerTypeSelections)) {
          this.basicDetails.containerTypeSelections.push({
            category: 'CONTAINER_TYPE',
            dataOptionId: this.containerType.id,
            dataOption: this.containerType.name
          })
          this.containerType = ''
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure you have selected a container type option and it is not already in the current selections' })
        }
      },
      contains (item, list) {
        return list.find(({dataOptionId}) => dataOptionId === item.id)
      }
    },
    watch: {
      'effectiveTo.time' (newVal, oldVal) {
        if (this.basicDetails.effectiveTo !== newVal) {
          this.basicDetails.effectiveTo = newVal
        }
      },
      'effectiveFrom.time' (newVal, oldVal) {
        if (this.basicDetails.effectiveFrom !== newVal) {
          this.basicDetails.effectiveFrom = newVal
        }
      },
      'basicDetails.effectiveFrom' (newVal, oldVal) {
        if (this.effectiveFrom.time !== newVal) {
          this.effectiveFrom.time = newVal
        }
      },
      'basicDetails.effectiveTo' (newVal, oldVal) {
        if (this.effectiveTo.time !== newVal) {
          this.effectiveTo.time = newVal
        }
      },
      basicDetails: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.$emit('updating', newVal)
        }
      },
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.basicDetails)) {
            for (let prop in newVal) {
              if (this.basicDetails.hasOwnProperty(prop) && this.basicDetails[prop] !== newVal[prop]) {
                this.basicDetails[prop] = newVal[prop]
              }
            }
          }
        }
      }
    }
  }
</script>
<style scoped>
.fa {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// BasicDetails.vue?a0d3359e